module.exports = __webpack_public_path__ + "7f88510ed9268c64a79af0daa18c8461.svg";